import { useEffect } from 'react';
/* eslint-disable no-case-declarations */
import { useDebounceEffect } from 'ahooks';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import { useMemo, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGlobalStore } from 'lib/DataStore';
import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';
import { SemanticFilterItems } from 'lib/apis/services/NewPlpListiing/type';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { isEqual } from 'lodash';
import { usePlpStore } from '../../DataStore';
import { semanticFilterBox } from '../../constant';
import { FilterBoxDropDownRef } from '../element/FilterBox/FilterBoxItemDropDown';
import { usePushPopStateHistory } from './useBackForward';

export const useFilterBoxItems = () => {
  const { userDevice } = useGlobalStore();
  const { t } = useOwnTranslate('plp');

  const [openMenu, setOpenMenu] = useState(false);
  const allFilter = useRef<FilterBoxDropDownRef>(null);
  const { watch, formState, setValue, ...restMethods } =
    useFormContext<NewPlpTypes.DecodeUrlResultType>();
  const {
    setData,
    semanticFilterBox: computedSemantic,
    sematicFilterBoxOrdered: orderedField,
    currentFormData,
    sort
  } = usePlpStore();
  const formData = watch();


  // usePushPopStateHistory();

  //تمام فیلدهایی که نوعشون به صورت عددی تعریف شده
  const arrayNumberFields = useMemo(() => {
    return semanticFilterBox
      .filter((item) => item.type === 'ArrayNumber')
      .map((item) => item.fieldName);
  }, [semanticFilterBox]);

  useDebounceEffect(
    () => {
      if (Object.keys(formState.touchedFields).length > 0) {
        arrayNumberFields.forEach((item) => {
          if (isArray(get(formData, item))) {
            if ((formData[item] as string[]).includes("-1")) {
              formData[item] = [];
            }
          }
        });

        setData({ filterData: formData, page: 0, sort: sort },"useFilterBoxItems");
      }
    },
    [JSON.stringify(formData)],
    { wait: 500, maxWait: 1000 }
  );

  const checkActive = (item: SemanticFilterItems) => {
    const newData = watch();
    if (newData[item.fieldName] === null) return false;
    if (item.type === 'ArrayNumber' && isEmpty(newData[item.fieldName]))
      return false;
    if (
      item.type === 'RANGE' &&
      values(newData[item.fieldName]).every((rengeData) => rengeData === null)
    )
      return false;
    return true;
  };

  const clearField = (item: NewPlpTypes.SemanticFilterItems) => {
    setValue(
      item.fieldName,
      item.type === 'RANGE' ? { min: null, max: null } : null,
      {
        shouldDirty: true,
        shouldTouch: true,
      }
    );
    if (item.type === 'INTEGER') {
      setValue(`${item.fieldName}Exact`, false);
    }
  };

  useEffect(() => {
    const propTypeField = computedSemantic.find(
      (item) => item.fieldName === 'propertyType_IN'
    );

    if (propTypeField) {
      const propertyTypeValues = (
        propTypeField.values as NewPlpTypes.ArrayNumberFilterValueType[]
      ).map((item) => item.id);

      if (formState?.defaultValues &&
        !isEqual(formState.defaultValues.landuseType, formData.landuseType)) {
        setValue('propertyType_IN', propertyTypeValues);
      } else {
        if (formState?.defaultValues?.propertyType_IN &&
          Array.isArray(formState?.defaultValues?.propertyType_IN) &&
          formState?.defaultValues?.propertyType_IN?.length) {
          setValue('propertyType_IN', formState?.defaultValues?.propertyType_IN! as string[]);
        } else {
          setValue('propertyType_IN', propertyTypeValues);
        }
      }
    }
  }, [JSON.stringify(currentFormData.landuseType)]);

  return {
    t,
    checkActive,
    orderedField,
    // onCloseHandler,
    semanticFilterBox: computedSemantic,
    openMenu,
    allFilter,
    setOpenMenu,
    useDevice: userDevice,
    clearField,
    formState,
    restMethods: {
      setValue,
      ...restMethods,
    },
  };
};
